<template>
  <div>
    <!-- 会议列表组件 -->
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <van-tabs :class="[{'permit-nav':mobNavShow},'meeting-list-tab']" v-model="activeTab" @click="initData">

      <van-tab class="tab-list" v-for="ele in tabList" :key="ele.name" :title="ele.title" :name="ele.name">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-bottom: 80px">
          <div v-if="refreshTime && !meetingData.length">
            <empty-notice :image="'meeting'" :desc="'暂无会议~'"></empty-notice>
            <!--<p v-show="activeTab==='all'" class="text-center text-hv" @click="viewHistory()">查看历史会议 ></p>-->
          </div>

          <div class="custom-steps" v-else>
            <van-list v-model="loading" :finished="finished" class="pad-top"
                      :finished-text="finishedText" @load="onLoad">
              <van-cell-group v-for="(gpDoc, idx) in groupData" :key="idx"
                              :title="gpDoc.title" :name="idx">
                <van-swipe-cell v-for="(ele, idx) in gpDoc.list" :key="idx">
                  <meeting-list-cell :formatted-mt="ele" @click-cell="handleDetail(ele)">
                  </meeting-list-cell>
                  <template #right>
                    <van-button v-if="checkPermit(ele)" text="取消" type="danger" class="hgt-100-percent" square
                                @click="handleCancel(ele)"></van-button>
                    <van-button v-else square type="danger" class="hgt-100-percent" disabled>
                      <i class="fa fa-ban text-center" style="width: 28px"></i>
                    </van-button>
                    <van-button v-show="ele.status==='MEETING'" square type="primary" class="hgt-100-percent"
                                text="结束" @click="handleEnd(ele)"></van-button>
                  </template>
                </van-swipe-cell>
              </van-cell-group>
            </van-list>
          </div>

          <!--<div v-show="meetingData.length && activeTab==='all'" class="mar-top">
            <van-cell title="历史会议" is-link @click="viewHistory()"></van-cell>
          </div>-->
        </van-pull-refresh>

        <div class="mar-hor fixed-btn">
          <van-button block @click="handleReserve">预约会议</van-button>
        </div>
      </van-tab>

      <div v-show="activeTab==='all'" class="custom-sticky">
        <van-tag class="right-tag pull-right" mark type="warning" size="large"
                 @click="viewHistory()">历史会议<i class="fa fa-angle-right mar-lft-5"></i>
        </van-tag>
      </div>

      <cancel-sheet :show="showCancelPopup" :params="{mid: cancelMid}" @reload="initData()"
                    @handle-cancel="showCancelPopup = $event"></cancel-sheet>

    </van-tabs>
  </div>

</template>

<script>
  import {commonConfig} from "../../../../config/common"
  import {
    checkRespCorrect,
    checkShowPermit,
    formatMListDoc,
    frontConfirm,
    refreshDebounce,
    sortMeeting,
    savePagePosition,
    removePagePosition
  } from "../../../../tools/utils"
  import {meeting} from "../../../../server";
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import routerMeta from "../../router/routerMeta";
  import CancelSheet from "../../components/CancelSheet"
  import MeetingListCell from "../../components/MeetingListCell"

  export default {
    components: {
      CancelSheet,
      MeetingListCell,
    },
    data() {
      return {
        meetingData: [],
        refreshing: false,
        activeTab: "attend",
        activeNames: [0],
        // ntoShowEnded: true,  // 默认不显示结束的会议
        tabMap: {
          attend: "我参加的",
          reserve: "我预约的",
          all: "我的全部",
        },
        showCancelPopup: false,
        cancelMid: "",
        refreshTime: "",
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
        loading: false,
        finished: false,
      }
    },
    computed: {
      userId() {
        return this.$store.state.userId || getStorage(StorageKey.userId)
      },
      tabList: function () {
        const list = Object.keys(this.tabMap).map(k => ({
          name: k,
          title: this.tabMap[k]
        }));
        if (checkShowPermit(this.$store.state.permissionList || [], this.permitsMap.copyTo)) {
          list.splice(2, 0, {name: "ccTo", title: "抄送我的"})
        }
        return list
      },
      rowData: function () {
        return this.meetingData.map(ele => formatMListDoc(ele, this))
      },
      finishedText: function () {
        return this.refreshTime && this.finished ? "没有更多了" : ""
      },
      groupData: function () {
        const groups = {};
        this.rowData.forEach(mt => {
          const title = `${mt.dateTime} ${mt.weekDay}`;
          if (groups[title]) {
            groups[title].push(mt)
          } else {
            groups[title] = [mt]
          }
        });
        // console.log(groups);
        return Object.keys(groups).map(k => ({
          title: k,
          list: this.activeTab === 'all' ? groups[k] : groups[k].sort(sortMeeting)
        }))
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    watch: {
      'groupData'() {
        // console.log(val);
        const idx = this.groupData.findIndex(e => e.list.length);
        this.activeNames = [idx];
      },
    },
    created() {
      const {activeTab} = this.$route.query;
      activeTab && (this.activeTab = activeTab);
    },
    mounted() {
      // this.initData()
    },
    methods: {
      onRefresh() {
        // 刷新防抖动
        if (this.refreshing && this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        // console.log(this.refreshing);
        this.initData()
      },
      onLoad() {
        this.getMeetingList(this.pageInfo.pageNum++);
      },
      initData() {
        this.pageInfo.pageNum = 1;
        this.meetingData = [];
        this.finished = false;
        this.refreshTime = "";
        this.onLoad()
      },
      getMeetingList(pageNum) {
        // console.log({pageNum});
        const filter = {
          pageNum,
          pageSize: this.pageInfo.pageSize,
          getIsUserCheckin: true,
          timeSort: 1,
        };
        // 根据不同tab拿取数据
        switch (this.activeTab) {
          case 'attend':
            filter.userId = this.userId;
            filter.meetingStatus = commonConfig.normalStatus;
            break;
          case 'reserve':
            filter.createdBy = this.userId;
            filter.meetingStatus = commonConfig.normalStatus;
            break;
          case 'ccTo':
            filter.ccUserId = this.userId;
            filter.meetingStatus = commonConfig.normalStatus;
            break;
          case 'all':
            filter.createdBy = this.userId;
            filter.userId = this.userId;
            filter.ccUserId = this.userId;
            filter.dateRange = {
              start: moment().startOf('day').valueOf()  // 不查询今天以前的会议
            };
            break;
          default:
        }
        // 初次加载时显示加载圈
        if (!this.refreshing && !this.refreshTime) {
          UILoader.load()
        }
        // 查询会议
        meeting.queryList(this, {queryFilter: filter}).then(({searchMeeting: data = {}}) => {
          this.loading = false;
          UILoader.unload();
          // console.log(data);
          const {meetingEdges, pageInfo} = data;
          this.meetingData = this.meetingData.concat(meetingEdges || []);
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || this.pageInfo.pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
          if (pageNum === 1) {
            this.refreshTime = new Date();
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        })
      },
      checkPermit(ele) {
        const selfReserved = (ele.reservedBy && ele.reservedBy.userId === this.userId)
          || (ele.sponsor && ele.sponsor.userId === this.userId)
          || (ele.initiator && ele.initiator.userId === this.userId);
        return selfReserved && commonConfig.preStatus.includes(ele.status)
      },
      handleCancel(doc) {
        this.cancelMid = doc.mid;
        this.showCancelPopup = true;
      },
      handleEnd(doc) {
        frontConfirm({msg: `是否确认结束【${doc.subject}】？`}, () => {
          // console.log(doc);
          UILoader.load("执行中...");
          meeting.finishMeeting(this, {mid: doc.mid}).then(({finishMeeting: resp = {}}) => {
            if (checkRespCorrect(resp, "保存失败")) {
              messageHdl({code: msgCode.SUCCESS});
              this.initData()
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        })
      },
      handleReserve() {
        this.$router.push({name: routerMeta.meetingReserve.name})
      },
      handleDetail(doc) {
        savePagePosition('meetingList')
        this.$router.push({name: routerMeta.meetingDetail.name, params: {mid: doc.mid}})
      },
      viewHistory() {
        localStorage.removeItem('history')
        this.$router.push({name: routerMeta.meetingHistoryList.name})
      },
    },
    activated() {
      window.scroll(0, localStorage.getItem("meetingList"))
      removePagePosition()
    },
    beforeRouteLeave(to, from, next) {
      // 只有在跳转到详情页时才需要保持当前页面
      from.meta.keepAlive = to.name === routerMeta.meetingDetail.name;
      next();
    }
  }
</script>


<style lang="less">
  .meeting-list-tab {
    .van-tabs__wrap {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }

    .van-tabs__content {
      margin-top: 45px;
    }
  }

  .custom-sticky {
    position: fixed;
    top: 65px;
    right: 0;
  }

  .permit-nav {
    .van-tabs__wrap {
      top: 45px;
    }

    .custom-sticky {
      top: 110px
    }
  }
</style>

